import {Center, Flex, Image, Spinner, useTheme} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import {navigateBackOrHome} from '../../../utils/history';
import SignupRequiredModal from '../../../components/SignupRequiredModal';
import {fetchPublicOffer} from '../../../endpoints/api';
import useAuth from '../../../hooks/useAuth';
import {useFetchPublicPlace} from '../../../hooks/useFetchPlace';
import useOfferModal from '../../../hooks/useOfferModal';
import {isMobile} from '../../../utils/deviceCheck';
import Header from '../Header';
import PlaceHelmet from '../PlaceHelmet';
import PlaceTabs from '../Tabs';

const PlacePreview = () => {
  const {uuid} = useParams();
  const {data, isLoading, refetch} = useFetchPublicPlace(uuid);
  const place = data?.data;
  const [signUpRequiredOpen, setSignUpRequiredOpen] = useState(false);
  const theme = useTheme();
  const {user} = useAuth();
  const [searchParams] = useSearchParams();

  const [inviteCode, setInviteCode] = useState('');
  const [qrCodeId, setQRCodeId] = useState('');

  useEffect(() => {
    if (!!searchParams.get('invite-code') && searchParams?.get('invite-code') !== '') {
      setInviteCode(searchParams?.get('invite-code') || '');
    }

    if (!!searchParams.get('qr_code_id') && searchParams?.get('qr_code_id') !== '') {
      setQRCodeId(searchParams?.get('qr_code_id') || '');
    }
  }, [searchParams]);

  const onSignupClicked = () => {
    if (window.self !== window.top) {
      // The page is being rendered in an iframe
      window.top ? (window.top.location.href = 'https://my.walkabout.app/register') : null;
      return;
    } else {
      // The page is not in an iframe
      if (user) {
        navigate('/download');
      } else if (inviteCode) {
        navigate('/register', {state: {code: inviteCode, qrCodeId: qrCodeId}});
      } else if (qrCodeId) {
        navigate('/register', {state: {qrCodeId: qrCodeId}});
      } else {
        navigate('/register');
      }
    }
  };

  const navigate = useNavigate();
  const {showOfferModal} = useOfferModal();

  useEffect(() => {
    if (searchParams.get('offer')) {
      fetchPublicOffer(searchParams.get('offer'))
        .then((response) => {
          // Check if response and data exist
          if (!response || !response.data) {
            throw new Error('No data available'); // This will be caught in the `catch` block
          }

          const {data} = response;

          if (user && place && isMobile) {
            // Remove the old offer parameter before adding the new one
            const params = new URLSearchParams(searchParams);
            params.delete('offer');
            const currentQueryString = params.toString();

            // Construct the new path with the updated `offer` parameter
            const newPath = currentQueryString
              ? `/place/${place.id}?${currentQueryString}&offer=${data.id}`
              : `/place/${place.id}?offer=${data.id}`;

            navigate(newPath, {replace: true});
          } else {
            showOfferModal({offer: data, isPreview: true});
          }
        })
        .catch(() => {
          if (user && place) {
            const queryString = searchParams.toString();
            const newPath = queryString
              ? `/place/${place.id}?${queryString}`
              : `/place/${place.id}`;

            isMobile ? navigate(newPath, {replace: true}) : null;
          }
        });
    } else if (user && place) {
      const queryString = searchParams.toString();
      const newPath = queryString ? `/place/${place.id}?${queryString}` : `/place/${place.id}`;

      isMobile ? navigate(newPath, {replace: true}) : null;
    }
  }, [user, place, searchParams.get('offer')]);

  if (isLoading || place === undefined || (user && isMobile)) {
    return (
      <Center style={{minHeight: '100vh'}}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor={theme.colors.lightGrey}
          color={theme.colors.lightBlue}
          size="lg"
        />
      </Center>
    );
  }

  return (
    <>
      <PlaceHelmet place={place} />
      <Flex position="relative" height="275px">
        <BackButton onClick={() => navigateBackOrHome(navigate)} m={'.75rem'} pos="relative" />
        <Image
          src={place.default_media?.full_url}
          alt="cover image"
          position="absolute"
          width="100%"
          height="100%"
          objectFit="cover"
          zIndex="-1"
          borderBottomRadius="14px"
        />
        {/* <MediaGallery media={place.media} /> */}
      </Flex>
      <Header place={place} refetchPlace={refetch}/>
      <PlaceTabs
        setSignUpRequiredOpen={setSignUpRequiredOpen}
        preview
        place={place}
        placeOffers={place.offers}
        refetchPlace={refetch}
        disableLocation={() => {}}
      />
      <SignupRequiredModal
        isOpen={signUpRequiredOpen}
        setIsOpen={setSignUpRequiredOpen}
        onButtonClicked={onSignupClicked}
      />
    </>
  );
};

export default PlacePreview;
